import colors from "../../base/colors";
import typography from "../../base/typography";

/** Shared dialog heading replaces the duplicated legacy grey title bars. */
const dialogTitle = {
  styleOverrides: {
    root: {
      padding: "20px 24px",
      fontSize: typography.size.lg,
      fontWeight: 600,
      color: colors.dark.main,
      background: colors.surface.main,
      borderBottom: "1px solid " + colors.grey[300],
    },
  },
};
export default dialogTitle;
